var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var RangeSliderv3 = dynamicRequire('RangeSliderv3.jsx').default;
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');

class DimensionChooser extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.isUserEditing = false;
        this.input = null;

        this.state = {
            value: props.start,
            visibleValue: this.format(props.start)
        };
        this.dirty = false;
    }

    componentWillReceiveProps(nextProps) {
        let newState = {
            value: nextProps.start,
        }
        if (!this.dirty) {
            newState.visibleValue = this.format(nextProps.start, nextProps.isCmMode);
            newState.error = false;
        }
        this.setState(newState);
    }

    render() {
        return <div
            className={"lr-casefactory-choices-sliders-dimensions-slider slider " + (this.state.error ? 'lr-casefactory-choices-sliders-dimensions-slider-error error' : '')}>
            <label><Mssg __key={this.props.label} /></label>
            <div className="lr-casefactory-choices-sliders-dimensions-dimension-input dimension-input">
                <input type="text" name="width"
                       ref={(ref) => this.input = ref}
                       className={"lr-casefactory-choices-input input " + (this.props.isCmMode ? ' cm' : ' mm')}
                       value={this.state.visibleValue}
                       onChange={this.onChange}
                       onKeyDown={this.onKeydown}
                       onClick={this.onClick}
                       onBlur={this.onBlur}
                />
                <span className="lr-casefactory-choices-sliders-dimensions-dimension-unit dimension-unit"> {this.getCmOrMm()}
                </span>
            </div>
            <div className="lr-casefactory-choices-sliders-dimensions-validation validation">
                <Mssg __key ='nc_casefactory.dimensions.validation2'
                      __parameters={{
                          min: this.forceFormat(this.props.range.min),
                          max: this.forceFormat(this.props.range.max),
                          unit: this.getCmOrMm()
                      }}
                />
            </div>
            <div className="lr-casefactory-choices-sliders-dimensions-slider-line slider-line">
                <RangeSliderv3 range={[this.props.range.min, this.props.range.max]}
                               onRelease={(values) => {
                                   this.dirty = false;
                                   this.context.emitter.emit('dimensionChange', this.props.dimension, Math.round(values[0]))
                               }}
                               points={this.getSnapPoints()}
                               onChange={(value) => {
                                   this.dirty = false;
                                   this.context.emitter.emit('dimensionDrag', this.props.dimension, Math.round(value))
                               }}
                               value={this.props.start}
                >
                </RangeSliderv3>
            </div>
        </div>
    }

    getMmValue(value) {
        return this.props.isCmMode ? (value * 10) : value;
    }

    getCmOrMm() {
        if (this.props.isCmMode) {
            return resolveLanguage("nc_casefactory.centimeter");
        } else {
            return 'mm';
        }
    }

    format(number, isCmMode) {
        if(this.isUserEditing) {
            return number;
        }else{
            return this.forceFormat(number, isCmMode);
        }
    }

    forceFormat(number, isCmMode = this.props.isCmMode) {
        if (isNaN(number)) {
            return number;
        }
        let parsedNumber;
        if (isCmMode) {
            parsedNumber = number / 10;
        } else {
            parsedNumber = number;
        }

        if (this.clampToRange(number) != number) {
            return number;
        } else {
            return parsedNumber.toLocaleString();
        }
    }

    getSnapPoints() {
        let snapPoints = [];
        let i;
        if (!this.props.isCmMode) {
            for (i = this.props.range.min; i <= this.props.range.max; i++) {
                snapPoints.push(i);
            }
            return snapPoints;
        } else {
            for (i = this.props.range.min; i <= this.props.range.max; i = i + 10) {
                snapPoints.push(i);
            }
            return snapPoints;
        }
    }

    onClick() {
        this.input.select();
    }

    onChange(e) {
        this.dirty = true;
        this.isUserEditing = true;

        this.setState({
            visibleValue: e.target.value,
        });
    }

    onBlur(e) {
        this.isUserEditing = false;
        let value = this.getValue(e.target.value);

        if (!isNaN(value) && value == this.clampToRange(value)) {
            this.context.emitter.emit('dimensionChange', this.props.dimension, value);
            this.dirty = false;
            this.setState({
                error: false,
                value: value,
                visibleValue: this.format(value),
            });
        } else {
            this.setState({
                error: true,
                visibleValue: e.target.value,
            });
        }
    }

    getValue(value) {
        if (this.isUserEditing) {
            return value;
        }

        let parsedValue = this.getMmValue(parseFloat(value));
        if (isNaN(parsedValue)) {
            return value;
        } else {
            return parsedValue;
        }
    }

    onKeydown(e) {
        if (e.which == 13) {
            this.onBlur(e);
        }
    }

    clampToRange(number) {
        return Math.max(this.props.range.min, Math.min(this.props.range.max, number));
    }
}

DimensionChooser.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};

module.exports = DimensionChooser;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/DimensionChooser.jsx